export const actionTypes = {
  TAX_EXEMPTIONS_REQUEST_START: 'PROFILE.TAX_EXEMPTIONS.TAX_EXEMPTIONS_REQUEST_START',
  TAX_EXEMPTIONS_REQUEST_SUCCESS: 'PROFILE.TAX_EXEMPTIONS.TAX_EXEMPTIONS_REQUEST_SUCCESS',
  TAX_EXEMPTIONS_REQUEST_FAILURE: 'PROFILE.TAX_EXEMPTIONS.TAX_EXEMPTIONS_REQUEST_FAILURE',
};

export function taxExemptionsStartRequest() {
  return {
    type: actionTypes.TAX_EXEMPTIONS_REQUEST_START,
  };
}

export function taxExemptionsRequestSuccess(data) {
  return {
    type: actionTypes.TAX_EXEMPTIONS_REQUEST_SUCCESS,
    payload: data,
  };
}

export function taxExemptionsRequestFailure(error) {
  return {
    type: actionTypes.TAX_EXEMPTIONS_REQUEST_FAILURE,
    payload: error,
  };
}
